<template>
  <v-app style="background-color: #eef2f5">
    <v-main style="background-color: #eef2f5">
      <aside
        :class="is_expanded ? 'is-expanded' : ''"
        style="position: fixed; z-index: 99"
      >
        <div class="logo">
          <img
            src="../../assets/Epicorlogo.jpg"
            alt="DVT"
          />
        </div>
        <div class="menu">
          <router-link
            to="/home"
            class="button d-flex justify-around align-center"
          >
            <span @click="changeExpand(0)"
              ><v-icon class="d-flex material-icons">{{
                "mdi-home"
              }}</v-icon></span
            >
            <span
              @click="changeExpand(0)"
              class="text width-100 d-flex justify-center align-center"
              >Home</span
            >
          </router-link>
          <div
            class="button d-flex justify-around button_menu"
            @click="ToggleMenu"
          >
            <span
              ><v-icon class="d-flex material-icons">{{
                "mdi-menu"
              }}</v-icon></span
            >
            <span
              class="text width-100 d-flex justify-center button_menu align-center"
              >Menu</span
            >
          </div>
          <div class="menu_list" @click="changeExpand(0)">
            <router-link
              v-if="getPermission.case"
              @click="changeExpand(0)"
              to="/case-service-request"
              class="button d-flex justify-around"
            >
              <span @click="changeExpand(0)">
                <v-icon class="d-flex material-icons">{{
                  "mdi-ticket"
                }}</v-icon></span
              >
              <span
                @click="changeExpand(0)"
                class="text width-100 d-flex justify-start align-center"
                >Cases/Service Request</span
              >
            </router-link>
            <router-link
              v-if="getPermission.call"
              to="/service-calls"
              class="button d-flex justify-around"
            >
              <span @click="changeExpand(0)"
                ><v-icon class="d-flex material-icons">{{
                  "mdi-monitor-cellphone"
                }}</v-icon></span
              >
              <span
                @click="changeExpand(0)"
                class="text width-100 d-flex justify-start align-center"
                >Service Calls</span
              >
            </router-link>
            <router-link
              to="/service-jobs"
              class="button d-flex justify-around"
              v-if="getPermission.job"
            >
              <span @click="changeExpand(0)"
                ><v-icon class="d-flex material-icons">{{
                  "mdi-calendar-month"
                }}</v-icon></span
              >
              <span
                @click="changeExpand(0)"
                class="text width-100 d-flex justify-start align-center"
                >Service Job Calendar</span
              >
            </router-link>
            <router-link
              to="/service-jobs1"
              class="button d-flex justify-around"
              v-if="getPermission.job"
            >
              <span @click="changeExpand(0)"
                ><v-icon class="d-flex material-icons">{{
                  "mdi-calendar-month"
                }}</v-icon></span
              >
              <span
                @click="changeExpand(0)"
                class="text width-100 d-flex justify-start align-center"
                >Service Job Board</span
              >
            </router-link>
            <router-link
              to="/project-jobs"
              class="button d-flex justify-around"
              v-if="getPermission.job"
            >
              <span @click="changeExpand(0)"
                ><v-icon class="d-flex material-icons">{{
                  "mdi-projector-screen-variant"
                }}</v-icon></span
              >
              <span
                @click="changeExpand(0)"
                class="text width-100 d-flex justify-start align-center"
                >Project Jobs</span
              >
            </router-link>
            <router-link
              to="/assets-equips"
              class="button d-flex justify-around"
              v-if="getPermission.equip"
            >
              <span @click="changeExpand(0)"
                ><v-icon class="d-flex material-icons">{{
                  "mdi-forklift"
                }}</v-icon></span
              >
              <span
                @click="changeExpand(0)"
                class="text width-100 d-flex justify-start align-center"
                >Assets/Equipments</span
              >
            </router-link>
            <router-link
              to="/invoices"
              class="button d-flex justify-around"
              v-if="getPermission.invoice"
            >
              <span @click="changeExpand(0)"
                ><v-icon class="d-flex material-icons">{{
                  "mdi-receipt-text-check-outline"
                }}</v-icon></span
              >
              <span
                @click="changeExpand(0)"
                class="text width-100 d-flex justify-start align-center"
                >Invoices</span
              >
            </router-link>
            <router-link
              to="/service-contracts"
              class="button d-flex justify-around"
              v-if="getPermission.contract"
            >
              <span @click="changeExpand(0)"
                ><v-icon class="d-flex material-icons">{{
                  "mdi-file-sign"
                }}</v-icon></span
              >
              <span
                @click="changeExpand(0)"
                class="text width-100 d-flex justify-start align-center"
                >Service Contracts</span
              >
            </router-link>
            <router-link
              to="/quote-management"
              class="button d-flex justify-around"
              v-if="getPermission.quote"
            >
              <span @click="changeExpand(0)"
                ><v-icon class="d-flex material-icons">{{
                  "mdi-file-eye"
                }}</v-icon></span
              >
              <span
                @click="changeExpand(0)"
                class="text width-100 d-flex justify-start align-center"
                >Quote Management</span
              >
            </router-link>
            <router-link
              to="/order-management"
              class="button d-flex justify-around"
              v-if="getPermission.order"
            >
              <span @click="changeExpand(0)"
                ><v-icon class="d-flex material-icons">{{
                  "mdi-book-open"
                }}</v-icon></span
              >
              <span
                @click="changeExpand(0)"
                class="text width-100 d-flex justify-start align-center"
                >Order Management</span
              >
            </router-link>
            <router-link
              to="/shipment-management"
              class="button d-flex justify-around"
              v-if="getPermission.shipment"
            >
              <span @click="changeExpand(0)"
                ><v-icon class="d-flex material-icons">{{
                  "mdi-truck-fast"
                }}</v-icon></span
              >
              <span
                @click="changeExpand(0)"
                class="text width-100 d-flex justify-start align-center"
                >Shipment Management</span
              >
            </router-link>
            <router-link
              to="/rma-management"
              class="button d-flex justify-around"
              v-if="getPermission.rma"
            >
              <span @click="changeExpand(0)"
                ><v-icon class="d-flex material-icons">{{
                  "mdi-glass-fragile"
                }}</v-icon></span
              >
              <span
                @click="changeExpand(0)"
                class="text width-100 d-flex justify-start align-center"
                >RMA Management</span
              >
            </router-link>
            <router-link
              to="/inventory-management"
              class="button d-flex justify-around"
              v-if="getPermission.rma"
            >
              <span @click="changeExpand(0)"
                ><v-icon class="d-flex material-icons">{{
                  "mdi-warehouse"
                }}</v-icon></span
              >
              <span
                @click="changeExpand(0)"
                class="text width-100 d-flex justify-start align-center"
                >Inventory Management</span
              >
            </router-link>
            <router-link
              to="/memo"
              class="button d-flex justify-around"
              v-if="getPermission.rma"
            >
              <span @click="changeExpand(0)"
                ><v-icon class="d-flex material-icons">{{
                  "mdi-message-badge"
                }}</v-icon></span
              >
              <span
                @click="changeExpand(0)"
                class="text width-100 d-flex justify-start align-center"
                >Memo</span
              >
            </router-link>
            <router-link
              to="/user-management"
              class="button d-flex justify-around"
            >
              <span @click="changeExpand(0)"
                ><v-icon class="d-flex material-icons">{{
                  "mdi-account-details"
                }}</v-icon></span
              >
              <span
                @click="changeExpand(0)"
                class="text width-100 d-flex justify-start align-center"
                >User Management</span
              >
            </router-link>
          </div>
        </div>
        <div class="flex"></div>
        <div class="menu">
          <router-link
            to="/field-help"
            class="button d-flex justify-around align-center"
            :custom="true"
            v-slot="{ href }"
          >
            <a :href="href" @click="changeExpand(0)">
              <span
                ><v-icon class="d-flex material-icons">{{
                  "mdi-help-circle-outline"
                }}</v-icon></span
              >
              <span class="text width-100 d-flex justify-center align-center"
                >Help</span
              >
            </a>
          </router-link>
          <router-link
            to="/"
            class="button d-flex justify-around align-center"
            :custom="true"
            v-slot="{ href }"
          >
            <a :href="href" @click="changeExpand(2)">
              <span
                ><v-icon class="d-flex material-icons">{{
                  "mdi-logout"
                }}</v-icon></span
              >
              <span class="text width-100 d-flex justify-center align-center"
                >Log Out</span
              >
            </a>
          </router-link>
        </div>
      </aside>
      <router-view
        :class="is_expanded ? 'is_expanded_route_content' : 'route_content'"
      ></router-view>
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      is_expanded: false,
    };
  },
  computed: {
    ...mapGetters("User", ["getUserInfo", "getPermission"]),
    endpoint() {
      // switch (this.$route.path) {
      //   case '/home':
      //     return '/field-help/homepage';
      //   case '/service-jobs':
      //     return '/field-help/calendar';
      //   case '/assets-equips':
      //   case '/invoices':
      //   case '/shipment-management':
      //   case '/service-contracts':
      //   case '/project-jobs':
      //   case '/service-calls':
      //   case '/case-service-request':
      //   case '/order-management':
      //   case '/rma-management':
      //   case '/inventory-management':
      //   case '/quote-management':
      //   case '/memo':
      //   case '/user-management':
      //     return '/field-help/datagrid';
      // }
      // return '';
      return "/field-help" + this.$route.path;
    },
  },
  methods: {
    changeExpand(index = 0) {
      index == 0
        ? (this.is_expanded = false)
        : this.$store.dispatch("User/logout");
    },
    ToggleMenu() {
      this.is_expanded = !this.is_expanded;
    },
  },
};
</script>

<style lang="scss" scoped>
.align-center {
  display: flex;
  justify-items: center;
  align-items: center;
}
.color-black {
  color: black;
}
.width-100 {
  width: 100%;
  height: 100%;
}
@import url("https://maxcdn.bootstrapcdn.com/font-awesome/4.4.0/css/font-awesome.min.css");
.menu_list {
  display: none;
}
.v-icon {
  color: black;
}
::-webkit-scrollbar {
  display: none;
}
aside {
  display: flex;
  flex-direction: column;
  background-color: #006780;
  color: black;
  width: calc(2rem + 25px);
  overflow: hidden;
  min-height: 100vh;
  padding: 1rem;
  transition: 0.2s ease-in-out;
  .button_menu {
    cursor: pointer;
  }
  span {
    text-decoration: none;
  }
  router-link {
    text-decoration: none;
  }

  .logo {
    margin-bottom: 1rem;
    img {
      width: 25px;
    }
  }
  h3,
  .button .text {
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    margin-left: 5px;
  }
  .text {
    opacity: 0;
    display: none;
    transition: opacity 0.3s ease-in-out;
    margin-left: 5px;
  }

  h3 {
    color: gray;
    font-size: 0.875rem;
    margin-bottom: 0.5rem;
    text-transform: uppercase;
  }

  .menu {
    margin: 0 -1rem;

    .button {
      display: flex;
      height: 50px;
      align-items: center;
      text-decoration: none;

      transition: 0.2s ease-in-out;
      padding: 0.5rem 1rem;

      .material-icons {
        align-items: center;
        color: white;
        transition: 0.2s ease-in-out;
      }

      .text {
        color: white;
        transition: 0.2s ease-in-out;
      }

      &:hover {
        background-color: white;
        .v-icon {
          color: white;
        }
        .material-icons,
        .text {
          color: black;
          text-decoration: none;
        }
      }
    }
  }
  &.is-expanded {
    width: 25vw;
    max-width: 20vw;
    h3,
    .button .text {
      opacity: 1;
    }

    .menu_list {
      display: flex;
      flex-direction: column;
      overflow: auto;
      max-height: 60vh;
      background-color: #006780;
      scrollbar-width: thin;
    }

    .button {
      height: 50px;
      .material-icons {
        margin-right: 1rem;
      }
    }

    .text {
      opacity: 1;
      color: #000;
      text-decoration: none;
    }
    @media (max-width: 1000px) {
      width: 30vw;
      max-width: 25vw;
    }
    @media (max-width: 800px) {
      width: 100vw;
      max-width: 100vw;
    }
  }
  @media (max-width: 1024px) {
    position: absolute;
    z-index: 99;
  }
}
.child-flex > *,
.flex {
  flex: 1 1 auto;
  max-width: 100%;
}
.is_expanded_route_content {
  width: calc(80vw);
  margin-left: calc(20vw) !important;
}
.route_content {
  padding-left: calc(2rem + 25px);
}
</style>
